import { config } from '@rematter/config';

import { LoadFormLineItem } from '~/modules/trade/types/load';

// Debug component to visualize line items
export type DebugPanelProps = {
  hidden?: boolean;
  formLineItems: LoadFormLineItem[];
  salesOrderLineItems?: LoadFormLineItem[];
};

export const DebugPanel = ({
  hidden,
  formLineItems,
  salesOrderLineItems,
}: DebugPanelProps) => {
  if (hidden || config.isDevelopment) return null;
  return (
    <div className="@DebugPanel mt-8 border-t border-neutral/20 pt-4">
      <h3 className="mb-4 text-base font-bold">Debug Panel</h3>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h4 className="mb-2 font-semibold">Form Line Items:</h4>
          <pre className="max-h-[400px] overflow-auto rounded bg-neutral/10 p-4 text-sm">
            {JSON.stringify(formLineItems, null, 2)}
          </pre>
        </div>
        {salesOrderLineItems && (
          <div>
            <h4 className="mb-2 font-semibold">Sales Order Line Items:</h4>
            <pre className="max-h-[400px] overflow-auto rounded bg-neutral/10 p-4 text-sm">
              {JSON.stringify(salesOrderLineItems, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};
